import { useEffect, useState } from 'react';
import './FountainRenderer.css';

const FountainRenderer = ({ content }) => {
  const [parsed, setParsed] = useState([]);

  useEffect(() => {
    const elements = parseFountain(content);
    setParsed(elements);
  }, [content]);

  return (
    <div className="fountain-screenplay">
      <div className="screenplay-page">
        {parsed.map((element, index) => {
          switch (element.type) {
            case 'title':
              return (
                <div key={index} className="screenplay-title-page">
                  <div className="title-content">
                    {element.lines.map((line, i) => (
                      <div key={i} className="title-line">{line}</div>
                    ))}
                  </div>
                </div>
              );
            case 'scene':
              return <div key={index} className="scene-heading">{element.text}</div>;
            case 'action':
              return <div key={index} className="action">{element.text}</div>;
            case 'character':
              return <div key={index} className="character">{element.text}</div>;
            case 'dialogue':
              return <div key={index} className="dialogue">{element.text}</div>;
            case 'parenthetical':
              return <div key={index} className="parenthetical">{element.text}</div>;
            case 'transition':
              return <div key={index} className="transition">{element.text}</div>;
            case 'centered':
              return <div key={index} className="centered">{element.text}</div>;
            case 'pagebreak':
              return <div key={index} className="page-break"></div>;
            case 'section':
              return <div key={index} className="section-heading">{element.text}</div>;
            case 'synopsis':
              return <div key={index} className="synopsis">{element.text}</div>;
            case 'note':
              return <div key={index} className="note">{element.text}</div>;
            default:
              return null;
          }
        })}
      </div>
    </div>
  );
};

// Fountain parser
function parseFountain(text) {
  const lines = text.split('\n');
  const elements = [];
  let inTitlePage = false;
  let titleLines = [];
  let i = 0;

  while (i < lines.length) {
    const line = lines[i];
    const trimmed = line.trim();

    // Title page (starts with Title:, Credit:, Author:, etc.)
    if (trimmed.match(/^(Title|Credit|Author|Source|Draft date|Contact):/i)) {
      if (!inTitlePage) {
        inTitlePage = true;
        titleLines = [];
      }
      titleLines.push(line);
      i++;
      continue;
    } else if (inTitlePage && trimmed === '') {
      elements.push({ type: 'title', lines: titleLines });
      inTitlePage = false;
      i++;
      continue;
    } else if (inTitlePage) {
      titleLines.push(line);
      i++;
      continue;
    }

    // Skip empty lines
    if (trimmed === '') {
      i++;
      continue;
    }

    // Page break
    if (trimmed === '===') {
      elements.push({ type: 'pagebreak' });
      i++;
      continue;
    }

    // Section heading
    if (trimmed.match(/^#+\s/)) {
      elements.push({ type: 'section', text: trimmed.replace(/^#+\s*/, '') });
      i++;
      continue;
    }

    // Synopsis
    if (trimmed.match(/^=\s/)) {
      elements.push({ type: 'synopsis', text: trimmed.replace(/^=\s*/, '') });
      i++;
      continue;
    }

    // Note
    if (trimmed.match(/^\[\[.*\]\]$/)) {
      elements.push({ type: 'note', text: trimmed.replace(/^\[\[|\]\]$/g, '') });
      i++;
      continue;
    }

    // Scene heading (INT., EXT., INT/EXT, I/E)
    if (trimmed.match(/^(INT|EXT|INT\.\/EXT|I\/E)[.\s]/i) || trimmed.match(/^\.[A-Z]/)) {
      const sceneText = trimmed.replace(/^\./, '');
      elements.push({ type: 'scene', text: sceneText });
      i++;
      continue;
    }

    // Centered text
    if (trimmed.match(/^>\s.*\s<$/)) {
      elements.push({ type: 'centered', text: trimmed.replace(/^>\s|\s<$/g, '') });
      i++;
      continue;
    }

    // Transition (TO:, FADE TO:, CUT TO:, etc.)
    if (trimmed.match(/^(TO:|FADE (TO|OUT|IN)|CUT TO):/i) || trimmed.match(/^>\s/)) {
      const transText = trimmed.replace(/^>\s*/, '');
      elements.push({ type: 'transition', text: transText });
      i++;
      continue;
    }

    // Character (ALL CAPS, possibly with extension)
    if (trimmed.match(/^[A-Z][A-Z\s]+(\s*\(.*\))?$/) && !trimmed.match(/^(FADE|CUT)/)) {
      elements.push({ type: 'character', text: trimmed });
      i++;

      // Look for dialogue and parentheticals
      while (i < lines.length) {
        const nextLine = lines[i].trim();
        
        if (nextLine === '') {
          break;
        }
        
        // Parenthetical
        if (nextLine.match(/^\(.*\)$/)) {
          elements.push({ type: 'parenthetical', text: nextLine });
          i++;
          continue;
        }
        
        // Dialogue
        if (nextLine && !nextLine.match(/^[A-Z][A-Z\s]+$/)) {
          elements.push({ type: 'dialogue', text: nextLine });
          i++;
          continue;
        }
        
        break;
      }
      continue;
    }

    // Action/description (default)
    elements.push({ type: 'action', text: line });
    i++;
  }

  return elements;
}

export default FountainRenderer;
